import React from "react";
import { Container, Typography, Box, Paper } from "@mui/material";
import { AllInclusive, VerifiedUserOutlined, FormatQuote } from "@mui/icons-material";
import styles from "../styles.module.scss";
import { clsx } from "@ismael1361/utils";
import { getVersion } from "shared/utils";

export const MainLayout: React.FC<{ children: React.ReactNode; isSecondary?: boolean; title?: string; subtitle?: string }> = ({
	children,
	isSecondary = false,
	title = "e-Keep",
	subtitle = "Sua equipe de IA, pronta para operar.",
}) => {
	if (isSecondary) {
		return (
			<>
				<div className={clsx(styles.mainChildren, styles.testimonialLayout)}>
					<Container className={styles.contentContainer}>
						<div className={styles.columnPattern} />
						<Paper
							elevation={0}
							className={styles.card}
						>
							<FormatQuote sx={{ fontSize: 40, color: "var(--mui-palette-primary-main)", mb: 1 }} />
							<Typography
								variant="h5"
								className={styles.testimonialText}
							>
								"Junte-se a centenas de profissionais que já automatizaram seus fluxos com o e-Keep"
							</Typography>
							<div className={styles.testimonialAuthor}>
								<div className={styles.authorAvatar}>JD</div>
								<div className={styles.authorInfo}>
									<Typography
										variant="subtitle2"
										sx={{ fontWeight: "bold" }}
									>
										João D.
									</Typography>
									<Typography
										variant="caption"
										sx={{ opacity: 0.6 }}
									>
										Tech Lead @ InovaAI
									</Typography>
								</div>
							</div>
						</Paper>
					</Container>
				</div>

				<Paper
					elevation={0}
					square
					className={clsx(styles.mainChildren, styles.secondaryLayout)}
				>
					<Container className={styles.contentContainer}>
						<div
							className={styles.header}
							style={{ textAlign: "left", marginBottom: "2rem" }}
						>
							<div
								className={styles.logoContainer}
								style={{ justifyContent: "flex-start" }}
							>
								<div className={styles.logoCircle}>
									<AllInclusive sx={{ fontSize: 24 }} />
								</div>
								<Typography
									variant="h4"
									component="h1"
									className={styles.title}
								>
									{title}
								</Typography>
							</div>
							<Typography
								variant="h6"
								sx={{ fontWeight: 700, mt: 3, mb: 1, lineHeight: 1.2 }}
							>
								{subtitle}
							</Typography>
						</div>
						{children}
					</Container>
				</Paper>
			</>
		);
	}

	return (
		<div className={styles.mainChildren}>
			<Container className={styles.contentContainer}>
				{/* Header */}
				<div className={styles.header}>
					<div className={styles.logoContainer}>
						<div className={styles.logoCircle}>
							<AllInclusive sx={{ fontSize: 24 }} />
						</div>
						<Typography
							variant="h4"
							component="h1"
							className={styles.title}
						>
							{title}
						</Typography>
					</div>
					<Typography
						variant="body2"
						sx={{ opacity: 0.5 }}
					>
						{subtitle}
					</Typography>
				</div>

				{children}
			</Container>

			{/* Footer */}
			<div className={styles.footer}>
				<Typography
					variant="caption"
					className={styles.footerText}
				>
					<VerifiedUserOutlined sx={{ fontSize: 14 }} />
					Segurança garantida por encriptação ponta a ponta
				</Typography>

				<div className={styles.footerVersion}>{getVersion()}</div>
			</div>
		</div>
	);
};
